export type * from './types/xor.js'
